import { z } from 'zod';
import { insightsGroupRowSchema } from './common';

export const TASKS_INSIGHTS_GROUP_BY = [
  'none',
  'client',
  'status',
  'priority',
  'assignee',
  'level',
  'cycle',
] as const;
export const tasksInsightsGroupBySchema = z.enum(TASKS_INSIGHTS_GROUP_BY);
export type TasksInsightsGroupBy = z.infer<typeof tasksInsightsGroupBySchema>;

export const TASKS_INSIGHTS_DATE_FIELDS = ['createdAt', 'dueDate', 'completedAt'] as const;
export const tasksInsightsDateFieldSchema = z.enum(TASKS_INSIGHTS_DATE_FIELDS);
export type TasksInsightsDateField = z.infer<typeof tasksInsightsDateFieldSchema>;

// Post-level tasks are compared against their parent post's target `date` rather than their own
// `dueDate`, so this metric only ever has a value for post-level task buckets.
export const tasksInsightsGroupRowSchema = insightsGroupRowSchema.extend({
  avgDaysBeforePostDate: z.number().nullable(),
});

export type TasksInsightsGroupRow = z.infer<typeof tasksInsightsGroupRowSchema>;

export const tasksInsightsResponseSchema = z.object({
  total: tasksInsightsGroupRowSchema,
  groups: z.array(tasksInsightsGroupRowSchema),
  groupBy: tasksInsightsGroupBySchema,
});

export type TasksInsightsResponse = z.infer<typeof tasksInsightsResponseSchema>;
